// Fills the badge from the LoyaltyLion span — async, and empty for non-earning
// products — so it stays hidden until a real number lands. Pre-promo = halved.

(function () {
  // Several carousel sections on a page each request this file.
  if (window.duskDoublePointsBadgeInit) return;
  window.duskDoublePointsBadgeInit = true;

  var NUDGE_SCHEDULE = [0, 800, 2000, 4000, 8000];
  var SETTLE_MS = 12000;

  function formatPoints(n) {
    try {
      return n.toLocaleString('en-GB');
    } catch (e) {
      return String(n);
    }
  }

  function refreshLion() {
    if (window.loyaltylion && window.loyaltylion.ui && window.loyaltylion.ui.refresh) {
      window.loyaltylion.ui.refresh();
    }
  }

  // True once resolved: no further attempts needed.
  function fill(badge) {
    var source = badge.querySelector('[data-lion-points-for-product-id]');
    var was = badge.querySelector('[data-double-points-was]');
    var now = badge.querySelector('[data-double-points-now]');
    if (!source || !was || !now) return true;

    var raw = (source.textContent || '').replace(/[^0-9]/g, '');
    if (raw === '') return false;

    var points = parseInt(raw, 10);
    if (!points) return true;

    now.textContent = formatPoints(points);
    was.textContent = formatPoints(Math.round(points / 2));
    badge.classList.add('double-points-badge--ready');
    return true;
  }

  function watch(badge) {
    var source = badge.querySelector('[data-lion-points-for-product-id]');
    if (!source || typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      if (fill(badge)) observer.disconnect();
    });
    observer.observe(source, { childList: true, subtree: true, characterData: true });
    setTimeout(function () {
      observer.disconnect();
    }, SETTLE_MS);
  }

  function init() {
    var badges = [].slice.call(document.querySelectorAll('[data-double-points-badge]'));
    var pending = badges.filter(function (badge) {
      return !fill(badge);
    });
    if (!pending.length) return;

    pending.forEach(watch);

    NUDGE_SCHEDULE.forEach(function (delay) {
      setTimeout(function () {
        if (
          pending.filter(function (badge) {
            return !badge.classList.contains('double-points-badge--ready');
          }).length
        ) {
          refreshLion();
        }
      }, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
